import { useEffect, useRef, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const IdleTimer = ({ timeout = 3600000, warningBefore = 300000 }) => {
  const navigate = useNavigate();
  const timer = useRef(null);
  const warningTimer = useRef(null);
  const [showWarning, setShowWarning] = useState(false);

  const logout = useCallback(async () => {
    setShowWarning(false);
    await supabase.auth.signOut();
    navigate('/login');
  }, [navigate]);

  const resetTimer = useCallback(() => {
    if (timer.current) clearTimeout(timer.current);
    if (warningTimer.current) clearTimeout(warningTimer.current);
    setShowWarning(false);

    warningTimer.current = setTimeout(() => {
      setShowWarning(true);
    }, timeout - warningBefore);

    timer.current = setTimeout(logout, timeout);
  }, [logout, timeout, warningBefore]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
    for (const event of events) {
      window.addEventListener(event, resetTimer);
    }

    resetTimer();

    return () => {
      for (const event of events) {
        window.removeEventListener(event, resetTimer);
      }
      clearTimeout(timer.current);
      clearTimeout(warningTimer.current);
    };
  }, [resetTimer]);

  return (
    <>
      {showWarning && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm text-center">
            <h2 className="text-lg font-semibold mb-4">Are you still there?</h2>
            <p className="mb-6">You’ll be logged out in 5 minutes due to inactivity.</p>
            <button
              onClick={resetTimer}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Stay Logged In
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default IdleTimer;
